import {AxiosResponse} from "axios";
import XLSX, {WorkBook} from "xlsx";
import {
    CallEffect,
    put,
    PutEffect,
    takeLatest,
    SelectEffect,
    all,
    select,
} from "redux-saga/effects";

import {
    ContentAvailabilityAction, Nullable, safeSaga,
} from "@data-force/app";
import {GET_FAQ_LIST} from "../actions/availableActions";
import {setFaqList} from "../actions/faq";
import {SetFaqListAction} from "../../interfaces/store/actions/faq";
import {Faq} from "../../interfaces/store/actions/payload/faq";
import {setLoading} from "../actions/mask";
import {SetLoadingAction} from "../../interfaces/store/actions/mask";
import StoreState from "../../interfaces/store/storeState";

type GetFaqListIteratorType =
    SelectEffect
    | Promise<void | AxiosResponse | Response>
    | PutEffect<SetLoadingAction | SetFaqListAction | ContentAvailabilityAction>
    | CallEffect;

function* getFaqListHandler(): IterableIterator<GetFaqListIteratorType> {
    yield put(setLoading(true));

    const fileUrl: Nullable<string> = yield select(
        (state: StoreState): Nullable<string> => state.serviceProperties.faqFileUrl,
    );
    if (fileUrl) {
        let faqData: Faq[] = [];
        yield fetch(fileUrl).then((res: Response) => res.arrayBuffer()).then((arrayBuffer:ArrayBuffer) => {
            /* parse the data when it is received */
            const data: Uint8Array = new Uint8Array(arrayBuffer);
            const workBook: WorkBook = XLSX.read(data, {type: "array"});
            const firstSheetName: string = workBook.SheetNames[0];
            faqData = XLSX.utils.sheet_to_json(
                workBook.Sheets[firstSheetName], {header: 0, raw: false},
            );
        });

        if (faqData.length) {
            yield put(setFaqList(faqData));
        }
    }

    yield put(setLoading(false));
}

export function* faqSagaActionWatcher() {
    yield all([
        takeLatest(GET_FAQ_LIST, safeSaga(getFaqListHandler)),
    ]);
}
